import React, { useRef, useEffect, useState } from "react";
import "./HeroSection.css";
import "../App.css";
import Navbar from "./Navbar";
import { FaInstagram } from "react-icons/fa";

function HeroSection({ media, userInteracted, centerText }) {
  const imageRef = useRef(null);
  const videoRef = useRef(null);
  const wrapperRef = useRef(null);
  const [showControls, setShowControls] = useState(false);
  const [muted, setMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);
  const [volume, setVolume] = useState(0);
  let hasUserInteracted = userInteracted;

  const updateWrapperHeight = () => {
    if (media.type === "video" && videoRef.current && wrapperRef.current) {
      wrapperRef.current.style.height = `${videoRef.current.offsetHeight}px`;
    } else if (
      media.type === "image" &&
      imageRef.current &&
      wrapperRef.current
    ) {
      const image = imageRef.current;
      const intrinsicHeight = image.naturalHeight;
      const intrinsicWidth = image.naturalWidth;
      const aspectRatio = intrinsicWidth / intrinsicHeight;
      const wrapperWidth = wrapperRef.current.offsetWidth;
      const wrapperHeight = wrapperWidth / aspectRatio;
      wrapperRef.current.style.height = `${wrapperHeight}px`;
    }
  };

  useEffect(() => {
    if (media.type === "video" && videoRef.current && wrapperRef.current) {
      videoRef.current.muted = true;
      wrapperRef.current.style.height = `${videoRef.current.offsetHeight}px`;
      videoRef.current.addEventListener("loadedmetadata", updateWrapperHeight);
      window.addEventListener("resize", updateWrapperHeight);

      videoRef.current.addEventListener("mouseover", () =>
        setShowControls(true)
      );
      videoRef.current.addEventListener("mouseout", () =>
        setShowControls(false)
      );
    } else if (
      media.type === "image" &&
      imageRef.current &&
      wrapperRef.current
    ) {
      const image = imageRef.current;
      const intrinsicHeight = image.naturalHeight;
      const intrinsicWidth = image.naturalWidth;
      const aspectRatio = intrinsicWidth / intrinsicHeight;
      const wrapperWidth = wrapperRef.current.offsetWidth;
      const wrapperHeight = wrapperWidth / aspectRatio;
      wrapperRef.current.style.height = `${wrapperHeight}px`;

      imageRef.current.addEventListener("load", updateWrapperHeight);
      window.addEventListener("resize", updateWrapperHeight);
    }

    window.addEventListener("scroll", heroSectionHandleScroll);
    window.addEventListener("click", handleUserInteraction);
    window.addEventListener("touchstart", handleUserInteraction);
    window.addEventListener("keydown", handleUserInteraction);

    return () => {
      window.removeEventListener("scroll", heroSectionHandleScroll);
      window.removeEventListener("click", handleUserInteraction);
      window.removeEventListener("touchstart", handleUserInteraction);
      window.removeEventListener("keydown", handleUserInteraction);
    };
  }, [videoRef, imageRef, wrapperRef]);

  const heroSectionHandleScroll = () => {
    if (videoRef.current) {
      const videoRect = videoRef.current.getBoundingClientRect();
      const scrollPosition = window.scrollY + window.innerHeight / 2;
      const videoMiddle = window.scrollY + videoRect.top + videoRect.height / 2;

      if (scrollPosition > videoMiddle + videoRect.height * 0.75) {
        if (!videoRef.current.paused) {
          videoRef.current.pause();
          setIsPlaying(false);
        }
      } else {
        if (videoRef.current.paused && hasUserInteracted) {
          videoRef.current.play();
          setIsPlaying(true);
        }
      }
    }
  };

  const handleUserInteraction = () => {
    hasUserInteracted = true;
  };

  const handleUnmute = () => {
    setMuted(!muted);
  };

  return (
    <div className="hero-container" ref={wrapperRef}>
      {media.type === "video" ? (
        <video
          className="hero-video"
          playsInline
          webkit-playsinline="true"
          preload="metadata"
          ref={videoRef}
          src={media.src}
          loop
          muted={muted}
          volume={volume}
          controls={showControls}
          onError={(e) => console.error("Video error:", e.target.error)}
          onLoadedMetadata={() => {
            if (!isPlaying) {
              videoRef.current.play();
              setIsPlaying(true);
            }
          }}
        />
      ) : (
        <img
          className="hero-image"
          src={media.src}
          ref={imageRef}
          alt="Hero Image"
        />
      )}

      <Navbar />

      {centerText && (
        <div className="hero-center-text">
          <h1>{centerText}</h1>
        </div>
      )}

      <a
        href="https://www.instagram.com/augusts_autumn?igsh=MWR0OXN4M2R4MGpwaw=="
        target="_blank"
        rel="noopener noreferrer"
        className="instagram-icon"
      >
        <FaInstagram />
      </a>
    </div>
  );
}

export default HeroSection;
